import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router';

import useAuthContext from 'hooks/useAuthContext';
import useSchoolContext from 'hooks/useSchoolContext';

import { NavDropDown, NavItem } from './components';

interface PropTypes {
  permanentSidebar?: boolean;
  toggleSidebar: () => void;
  navItems: Array<NavItem | NavDropDown>;
  colorInvert?: boolean;
}

function Topbar({ permanentSidebar = false, toggleSidebar, navItems, colorInvert = false }: PropTypes): JSX.Element {
  const theme = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // const { mode } = theme.palette;
  const schoolContext = useSchoolContext();
  const { accessToken, logout } = useAuthContext();

  return (
    <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} width={1}>
      <Link
        component={RouterLink}
        to="/"
        color={theme.palette.text.primary}
        underline="none"
        title={schoolContext?.name}
        sx={{
          display: 'flex',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          flexShrink: 1,
        }}
      >
        <Typography variant="h5" noWrap fontWeight="bold">
          {schoolContext?.name}
        </Typography>
      </Link>
      <Box
        sx={{
          display: {
            xs: 'none',
            md: permanentSidebar ? 'none' : 'flex',
          },
        }}
        alignItems={'center'}
        gap={4}
        marginLeft={4}
      >
        {navItems.map((navItem) => (
          <Box key={navItem.title}>
            {'items' in navItem ? (
              <NavDropDown
                title={navItem.title}
                id={navItem?.id ?? navItem.title}
                items={navItem.items}
                activeLink={pathname}
                colorInvert={colorInvert}
              />
            ) : (
              <NavItem
                title={navItem.title}
                id={navItem?.id ?? navItem.title}
                to={navItem.to}
                colorInvert={colorInvert}
              />
            )}
          </Box>
        ))}

        {(!accessToken || !pathname.startsWith('/student')) && (
          <Button component={RouterLink} to="/login" variant="contained" color="primary" size="medium">
            Login
          </Button>
        )}

        {accessToken && pathname.startsWith('/student') && (
          <Button
            // component={Link}
            // to="/login"
            variant="contained"
            color="primary"
            size="medium"
            onClick={async () => {
              await logout();
              navigate('/');
            }}
          >
            Logout
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: {
            xs: 'flex',
            md: permanentSidebar ? 'flex' : 'none',
          },
        }}
        alignItems={'center'}
      >
        <Button
          onClick={() => toggleSidebar()}
          aria-label="Menu"
          variant={'outlined'}
          sx={{
            borderRadius: 2,
            minWidth: 'auto',
            padding: 1,
            borderColor: alpha(theme.palette.divider, 0.2),
          }}
        >
          <MenuIcon />
        </Button>
      </Box>
    </Box>
  );
}

export default Topbar;
